import React from 'react';

import { Box, Breadcrumb, Heading, Text, Flash } from '@primer/components'
import { Link } from "react-router-dom";

import WaveHero from '../components/WaveHero';
import CodeReview from '../components/BeforeAfter/BeforeAfterHorizontal'
import Seo from '../components/Seo'

import { useProduct } from '../hooks/useProduct'
import { useCategory } from '../hooks/useCorpus'


export default function(props) {
  const productDetails = useProduct()
  const messageIds = useCategory(props.category).map(check => check.code)
  return (
    <Box>
      <Seo title={props.seoTitle} />
      <WaveHero>
        <Box className="container-lg lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/'} className="text-white">Home</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>{props.title}</Heading>
        </Box>
      </WaveHero>
      <div className="container-lg px-3 mb-9" style={{fontSize: "16px"}}>
        <Box alignItems="center" className="container-lg clearfix d-md-flex">
          <Box className="f3 col-md-6 float-left">
            <Text as="p">{props.synopsis_parageaph_one}</Text>
            <Text as="p">{props.synopsis_parageaph_two}</Text>
          </Box>
          <Box className="col-md-6 float-right">
            <img src={props.svgPath} width="100%" alt="Money" />
          </Box>
        </Box>
        <CodeReview examplesCodes={messageIds} />
        <Text as="p" className="f3 pt-md-4">Are you ready to improve your team agility through lower tech debt? <a href={productDetails.gitHubMarketplaceLink}>Add {productDetails.name} to GitHub</a>.</Text>
      </div>
    </Box>
  );
}
